/* eslint-disable no-unused-vars */
/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-09-02 17:06:12
 * @LastEditTime: 2019-09-09 13:21:00
 * @LastEditors: yingbin
 */
import request from '@/utils/request'
import utils from '@/utils/utils';
import store from '@/stores/index';
class companyApi {
	//企业资格认证
	companyAuth(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "company.certificate",
				url:"/company/certificate",
				data: {
					"userName":utils.getCookie("USER_INFO"),
					"token": utils.getCookie("TOKEN"),
					"companyId":self.companyId,
					"companyName": self.ruleForm.cp_name,
					"companyProvinceId": self.regionsCode[0],
					"companyProvince": self.regionsName[0],
					"companyCityId": self.regionsCode[1],
					"companyCity": self.regionsName[1],
					"companyCountyId": self.regionsCode[2],
					"companyCounty": self.regionsName[2],
					"companyDetailAddr": self.ruleForm.cp_address,
					"industry": self.ruleForm.industry,
					"creditUnionCode": self.ruleForm.creditCode,
					"cardImg": self.ruleForm.three_img,
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}
	// 获取省市区
	getAllregions(self, regionId, regionType) {
		return new Promise((resolve, reject) => {
			if(store.state.address){
				resolve({ success: true, data: store.state.address })
				return;
			}
			request.post(self, {
				action: "dict.getallregions",
				url:'/dict/getallregions',
				data: {
					"token": utils.getCookie("TOKEN")
				}
			}).then(res => {
				if (res.code == 20000) {
					if(res.data){
						store.state.address = res.data
					}
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}
	//获取公司认证信息
	getCompanyInfo(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "user.getcompanyinfo",
				url:'/user/getcompanyinfo',
				data: {
					"userName":utils.getCookie("USER_INFO"),
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}

	//获取公司认证信状态
	getAuditRecords(self, userId) {
		return new Promise((resolve, reject) => {
			request.post(self, {
				action: "audit.getauditrecords",
				url:"/audit/getauditrecords",
				data: {
					"userId": userId,
					"token": utils.getCookie("TOKEN"),
				}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}
}
export default new companyApi();